<template>
  <div style="height: 100vh !important" :class="isRevamp ? 'common-background-color-revamp-container' : 'common-background-color'
    ">
    <div :class="getIsUploadsPage ? 'uploads-full-height' : ''">
      <template v-if="isShowHeader">
        <template v-if="isRevamp">
          <CommonHeaderRevamp :currentMenu="currentMenu" />
        </template>
        <template v-else>
          <CommonHeader :currentMenu="currentMenu" />
        </template>
      </template>
      <router-view :class="getIsUploadsPage
        ? ''
        : isRevamp
          ? `common-background-color-revamp ${user.isAndroid
            ? 'full-height-revamp-android'
            : 'full-height-revamp-ios'}`
          : 'full-height'
        " />
      <Loading :active="isLoading" />
      <obj id="obj-data-appid" :value="user.loanAppId"></obj>
      <obj id="obj-data-cif" :value="user.cif"></obj>
      <obj id="obj-data-channel" :value="user.channel"></obj>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentMenu: {},
      productRevamp: process.env.VUE_APP_PRODUCT_REVAMP,
    };
  },
  components: {
    Loading: () => import("@/utils/Loading"),
    CommonHeader: () =>
      import("@/components/TemplateNewScreen/CommonHeader.vue"),
    CommonHeaderRevamp: () =>
      import("@/components/TemplateNewScreen/revamp/CommonHeader.vue"),
  },
  computed: {
    isShowHeader() {
      return (
        this.$route.name &&
        this.$route.name !== "NoAuthorized" &&
        this.$route.name !== "CallFromNext" &&
        this.$route.name !== "404" &&
        this.$route.name !== "LoginPage"
      );
    },
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
    user() {
      return this.$store.getters.getUserData;
    },
    getHeight() {
      // return window.innerHeight == 0 ? 650 : window.innerHeight;
      return window.innerHeight;
    },
    getIsUploadsPage() {
      return this.$route.name === "UploadPage";
    },
    isRevamp() {
      const pr = this.productRevamp.split(",");
      return (
        pr.includes(this.user.marketCode) &&
        this.$route.name !== "DstatementPage"
      );
    },
  },
  created() {
    // var h = window.innerHeight;
    // if (h == 0) h = 650;
    // var styleModalOpen = document.createElement("style");
    // styleModalOpen.type = "text/css";
    // styleModalOpen.innerHTML =
    //   ".modal-backdrop, .modal-content-custom ,.modal-open , .modal , .full-height { height: " +
    //   h +
    //   "px  !important ; } " +
    //   " .router-height{ height: " +
    //   (h - 45) +
    //   "px !important;}";
    // document.getElementsByTagName("head")[0].appendChild(styleModalOpen);
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      console.error(err);
    }
  },
  mounted() {
    this.$event.$on("update_current_menu", (data) => {
      this.currentMenu = data;
    });
  },
};
</script>

<style>
@import "assets/styles/main.css";
@import "assets/styles/mainRevamp.css";
</style>
<style>
.uploads-full-height {
  height: calc(100vh) !important;
}

.full-height {
  height: 90vh !important;
}

.full-height-revamp-android {
  height: calc(100vh) !important;
  overflow-y: scroll;
  padding: calc(13vh + 1rem) 1rem 1rem 1rem !important;
}

.full-height-revamp-ios {
  height: calc(100vh) !important;
  overflow-y: scroll;
  padding: calc(64px + 1rem) 1rem 1rem 1rem !important;
}
</style>
